import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const MyApiAddCard = ({ onClick }) => {
  const { t } = useTranslation("common");

  return (
    <button type="button" className="api-card add-card" onClick={onClick}>
      <div className="add-card-inner">
        <div className="add-card-icon">+</div>
        <div className="add-card-title">{t("Generate New API")}</div>
        <div className="add-card-sub">{t("Use the API Generator")}</div>
      </div>
    </button>
  );
};

MyApiAddCard.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default MyApiAddCard;
